<template>
  <page>
    <!-- <template slot="header"> 
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              Ordens de Serviço Externas
            </h3>
          </div>
          <div class="col-sm-6">
            <b-breadcrumb
              class="float-sm-right"
              :items="breadcrumbItems"
            ></b-breadcrumb>
          </div>
        </div>
      </div>
    </template> -->

    <template slot='content'>


      <os-externa-component></os-externa-component>
      <reloadPage></reloadPage>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsExternaComponent from '@/components/OsExternaComponent'
import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsExternaComponent,
    reloadPage
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },

  computed: {
    mecanico() {
      let mecanicoOs = JSON.parse(localStorage.filial);
      if (mecanicoOs.atendeOs == 'S') {
        return false
      } else {
        return true
      }
    }
  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens de Serviço',
          active: true
        }
      ],
      timer: ''
    }
  },
  created() {
  },
  methods: {
    reloadPage() {
      const host = window.location.pathname;
      let filial = JSON.parse(localStorage.filial);

      if (filial.fornecExt == 'S') {
        return false
      }
      
      this.timer = setTimeout(() => {
        if (host == "/" || host == "/osPreventiva") {
          this.$store.dispatch("os/fetchFromApi", {});
        } else if (host == '/osExterna') {
          this.$store.dispatch('os/fetchFromApiExterna') 
        }
        this.reloadPage();
      }, 1000 * 5);
      console.log(this.timer)

    }
  }
}
</script>
